// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2WHHW","bigColWidth":"Table_bigColWidth__1Vg01","biggerColWidth":"Table_biggerColWidth__3Ynca","row":"Table_row__28_wJ","col":"Table_col__3m1Rt"};